import * as angular from "angular";
import {IController} from "angular";

export class AgentRequirementsIconCtrl implements IController {

  type: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRequirementsIcon', {
    bindings: {
      type: '<'
    },
    template: require('./agent-requirements-icon.html').default,
    controller: AgentRequirementsIconCtrl
  });
